module.exports = __webpack_public_path__ + "static/media/eng.802641a4.svg";